import {useEffect, useRef} from 'react';

export const useScrollManagement = (currentPage) => {
	const prevPageRef = useRef(currentPage);

	useEffect(() => {
		// Only scroll when page changes to 1 (not on initial mount)
		if (currentPage === 1 && prevPageRef.current !== 1) {
			setTimeout(() => {
				window.scrollTo({top: 0, behavior: 'smooth'});
			}, 0);
		}
		prevPageRef.current = currentPage;
	}, [currentPage]);
};